var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.stats)?_c('div',[_c('div',{staticClass:"col-md-12"},[_c('issues-card',{attrs:{"registration":_vm.registration,"simulation":_vm.simulation,"stats":_vm.stats,"sync":_vm.sync},on:{"reload":function($event){return _vm.$emit('reload')}}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }